module.exports = ".navbar{\r\n    position: fiexd;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 900;\r\n}\r\n.qr-mena-appbar-dark {\r\n\tbackground-color: #171B1E !important\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/QrMena/components/header/header.component.css
// module id = ./src/QrMena/components/header/header.component.css
// module chunks = main